import { canv } from '@/canv/global.js'

export class shapeDelay {

    constructor() {

    }

    fitText(textPart, x, y, width, height, verticalPadding, horizontalPadding) {

        var allowedWidth = width * 7/8 - 2 * horizontalPadding;
        var allowedHeight = height - 2 * verticalPadding;


        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + width * 7/8 / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            "allowedWidth": allowedWidth,
            "allowedHeight": allowedHeight
        };
    }

    draw(x, y, width, height) {
        var r = height / 30;
        if (width < 2 * r) r = width / 2;

        canv.ctx.beginPath();
        canv.ctx.moveTo(x + width * 7/8, y);
        canv.ctx.arcTo(x, y, x, y + height, r);
        canv.ctx.arcTo(x, y + height, x + width * 7/8, y + height, r);
        canv.ctx.lineTo(x + width * 7/8, y + height);
        canv.ctx.ellipse(x + width * 7/8, y + height/2, width/8, height/2, 0, 1/2 * Math.PI, 3/2 * Math.PI, true);
        canv.ctx.closePath();
    }

    getAvatar(color) {
        return `
        <svg width="80" height="74" viewBox="0 0 80 74" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.360764 0.447608C5.41405 -0.3545 60.39 0.0738892 62.5217 0.550433C85.0857 4.40093 86.5554 68.9479 62.5217 72.8745C60.4172 73.4544 6.10506 73.5262 0.462242 72.9585C0.144287 72.9265 0 72.6855 0 72.366V0.954296C0 0.695219 0.104897 0.488223 0.360764 0.447608Z"
        fill="` + color + `"/>
        </svg>
        `;
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 25;
            height = 25;
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="` + width + `" height="` + height + `" viewBox="0 0 27 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.6529 1.11074C4.35071 0.900313 20.166 1.02925 20.8046 1.17201C27.8559 2.37529 28.3152 22.5462 20.8046 23.7733C20.1786 23.9458 4.77026 23.9744 1.7678 23.8238C1.44864 23.8078 1.2666 23.5843 1.2666 23.2647V1.57587C1.2666 1.3168 1.39461 1.13088 1.6529 1.11074Z" fill="` + fill + `" stroke="` + stroke + `"/>
            </svg>
        `;
    }

}
